export function createNewsApi(baseUrl) {
  return {
    news: {
      getNews: (id) => `${baseUrl}/v1/news/${id}/`,
      appLink: (id) => `${baseUrl}/v1/news/${id}/links/`,
    },
  };
}
